import {Dispatch, MiddlewareAPI, AnyAction} from 'redux';
import {MemberRequest} from './types';
import {
  EntityState,
  TAdd,
  emitMockPusherMessage,
} from '@di-nxt/resource-container';
import {Person} from '../person/types';

export const emitPusherMessages = (
  api: MiddlewareAPI<Dispatch<AnyAction>, {Person: EntityState<Person, 'id'>}>,
  action: TAdd<MemberRequest, 'MemberRequest'>,
) => {
  if (action.type === 'ADD_MemberRequest') {
    const state = api.getState();
    const request = action.payload.data[0];
    state['Person'].data.forEach(person => {
      if (person.mobileNo === request.mobileNo) {
        console.log('Found it', person);
        // Emit add_membership pusher message
        const newMembership = {
          personId: person.id,
          teamId: request.teamId,
          title: 'Courier',
        };
        emitMockPusherMessage(
          'Membership',
          request.teamId,
          'added',
          newMembership,
        );
      }
    });
  }
};
